import React from 'react';
import {
  Card,
  Pagination,
  PageSection,
  Title,
  Toolbar,
  ToolbarContent,
  ToolbarItem,
  PaginationVariant
} from '@patternfly/react-core';
import { Table, Thead, Tr, Th, Tbody, Td } from '@patternfly/react-table';
import { summaryFindingsRows, summaryFindingsColumns } from '@app/Findings/sampleData';
import { ChartDonut, ChartThemeColor } from '@patternfly/react-charts';
import { PRODUCT_NAME } from '../../config/partner';

export const summary: React.FunctionComponent = () => {
  const [page, setPage] = React.useState<number>(1);
  const [perPage, setPerPage] = React.useState<number>(10);
  const [paginatedRows, setPaginatedRows] = React.useState(summaryFindingsRows.slice(0, 10));

  const handleSetPage = (
    _evt: React.MouseEvent | React.KeyboardEvent | MouseEvent,
    newPage: number,
    _perPage: number,
    startIdx: number,
    endIdx: number
  ) => {
    setPaginatedRows(summaryFindingsRows.slice(startIdx, endIdx));
    setPage(newPage);
  };

  const handlePerPageSelect = (
    _evt: React.MouseEvent | React.KeyboardEvent | MouseEvent,
    newPerPage: number,
    newPage: number,
    startIdx: number,
    endIdx: number
  ) => {
    setPaginatedRows(summaryFindingsRows.slice(startIdx, endIdx));
    setPage(newPage);
    setPerPage(newPerPage);
  };

  const renderPagination = (variant: string, isCompact: boolean) => (
    <Pagination
      isCompact={isCompact}
      itemCount={summaryFindingsRows.length}
      page={page}
      perPage={perPage}
      onSetPage={handleSetPage}
      onPerPageSelect={handlePerPageSelect}
      variant={variant as PaginationVariant}
      titles={{
        paginationAriaLabel: `${variant} pagination`
      }}
    />
  );

  const tableToolbar = (
    <Toolbar usePageInsets id="compact-toolbar">
      <ToolbarContent>
        <ToolbarItem variant="pagination">{renderPagination('top', true)}</ToolbarItem>
      </ToolbarContent>
    </Toolbar>
  );

/*
  const renderLabel = (labelText: string) => {
    switch (labelText) {
      case 'Running':
        return <Label color="green">{labelText}</Label>;
      case 'Stopped':
        return <Label color="orange">{labelText}</Label>;
      case 'Needs Maintenance':
        return <Label color="blue">{labelText}</Label>;
      case 'Down':
        return <Label color="red">{labelText}</Label>;
      default:
        return <></>;
    }
  };

  const renderPriority = (priority: number) => {
    if (priority > highPriorityThresh) {
        return <Label color="red">{priority}</Label>;
    } else if (priority >= lowPriorityThresh) {
        return <Label color="orange">{priority}</Label>;
    } else {
        return <Label color="green">{priority}</Label>;
    }
  };
 */

  return (
    <React.Fragment>
        <PageSection isFilled>
          <Title headingLevel="h1" size="xl">{PRODUCT_NAME} Findings Summary</Title>
          <br />
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <div style={{ height: '230px', width: '450px' }}>
              <ChartDonut
                ariaDesc="Findings by priority"
                ariaTitle="Findings by priority"
                data={[{ x: 'High', y: 49 }, { x: 'Medium', y: 65 }, { x: 'Low', y: 120 }]}
                labels={({ datum }) => `${datum.x}: ${datum.y}`}
                style={{
                    data: {
                        fill: ({ datum }) => {
                            if (datum.x === 'High') {
                                return 'red';
                            } else if (datum.x === 'Medium') {
                                return 'orange';
                            } else if (datum.x === 'Low') {
                                return 'green';
                            }
                            return null;
                        }
                    }
                }}
                legendData={[{ name: 'High Priority: 49', symbol: { fill: 'red' }}, { name: 'Medium Priority: 65', symbol: { fill: 'orange' }}, { name: 'Low Priority: 120', symbol: { fill: 'green' }}]}
                legendOrientation="vertical"
                legendPosition="right"
                 padding={{
                   bottom: 20,
                   left: 50,
                   right: 200, // Adjusted to accommodate legend
                   top: 20
                 }}
                title="234"
                subTitle="Finding Priority"
                width={450}
                innerRadius={80}
                constrainToVisibleArea
              />
            </div>
            <div style={{ height: '230px', width: '450px' }}>
              <ChartDonut
                ariaDesc="Findings by type"
                ariaTitle="Findings by type"
                data={[{ x: 'Account', y: 7 }, { x: 'MFA', y: 84 }, { x: 'Protection', y: 143 }]}
                labels={({ datum }) => `${datum.x}: ${datum.y}`}
                legendData={[{ name: 'Account: 7'}, { name: 'MFA: 84'}, { name: 'Protection: 143'}]}
                legendOrientation="vertical"
                legendPosition="right"
                 padding={{
                   bottom: 20,
                   left: 50,
                   right: 200, // Adjusted to accommodate legend
                   top: 20
                 }}
                title="234"
                subTitle="Finding Type"
                width={450}
                innerRadius={80}
                themeColor={ChartThemeColor.multiOrdered}
                constrainToVisibleArea
              />
            </div>
          </div>
          <Card>
            {tableToolbar}
            <Table variant="compact" aria-label="Compact Table">
              <Thead>
                <Tr>
                  <Th key={0}>{summaryFindingsColumns[0]}</Th>
                  <Th key={1}>{summaryFindingsColumns[1]}</Th>
                  <Th key={2}>{summaryFindingsColumns[2]}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedRows.map((row, rowIndex) => (
                  <Tr key={rowIndex}>
                    <>
                      <Td dataLabel={summaryFindingsColumns[0]}>{row.Type}</Td>
                      <Td dataLabel={summaryFindingsColumns[1]}>{row.NumIdentified}</Td>
                      <Td dataLabel={summaryFindingsColumns[2]}>{row.NumFindings}</Td>
                    </>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Card>
        </PageSection>

    </React.Fragment>
  );
};
